import * as $ from "jquery";
import {initDateInput} from "../../forms";
import moment from "moment";

export const getTypeFromTree = (animalTypeId) => {
    let tree = [];
    if (typeof window._tree != 'undefined') {
        tree = JSON.parse(window._tree);
        tree = tree[Object.keys(tree)[0]]
    }

    return tree.find(a => parseInt(a.id) === parseInt(animalTypeId));
}

export const getSubtypeFromTree = (animalTypeId, animalId) => {
    let animalType = getTypeFromTree(animalTypeId);

    if (!animalType) {
        return;
    }

    return animalType.animals.find(a => parseInt(a.id) === parseInt(animalId));
}

export const buildItemFromForm = (form = null) => {
    if(form === null) {
        form = $('form');
    }

    let typeInput = form.find('[name="type"]');
    let subtypeInput = form.find('[name="subtype"]');
    let quantityInput = form.find('[name="quantity"]');
    let commentsInput = form.find('[name="comments"]');

    const inventoryType = parseInt(window._inventory_type);

    let item = {
        animal_type_id: typeInput.val(),
        animal_id: subtypeInput.val(),
        quantity: quantityInput.val() ?? 1,
        comments: commentsInput.val(),
        is_edited: false,
        details: []
    }

    if (inventoryType === 4) {
        item = {
            ...item,
            is_inspected: form.find('[name="is_inspected"]:last').is(":checked") ? 1 : 0,
            // settlement_type: $('[name="settlement_type"]').val(),
        }
    }

    let animal = getSubtypeFromTree(typeInput.val(), subtypeInput.val());
    if (animal) {
        for (let dictionary of animal.dictionaries) {
            let input = $(`[name="dictionary-${dictionary.id}"]`);
            if (input.length > 0) {
                if(input.val().length > 0) {
                    let value = input.val();
                    if(parseInt(dictionary.type) === 4) {
                        value = moment(value, "DD/MM/YYYY").format('X');
                    }

                    item = {
                        ...item,
                        details: [
                            ...item.details,
                            {
                                dictionary_id: dictionary.id,
                                value
                            }
                        ]
                    }
                }
            }
        }
    }

    return item;
}

export const itemFormCommon = () => {
    let typeInput = $('[name="type"]');
    let subtypeInput = $('[name="subtype"]');
    let dictionaryInputsContainer = $('.dictionary-inputs');

    let dictionaryInputTemplate = $('#dictionary-input').children();
    let dictionaryTextInputTemplate = $('#dictionary-text-input').children();
    let dictionaryNumberInputTemplate = $('#dictionary-number-input').children();
    let dictionaryDateInputTemplate = $('#dictionary-date-input').children();

    let tree = [];
    if (typeof window._tree != 'undefined') {
        tree = JSON.parse(window._tree);
        tree = tree[Object.keys(tree)[0]]
    }

    subtypeInput.change(function () {
        let animal = getSubtypeFromTree(typeInput.val(), subtypeInput.val());

        if (!animal) {
            return;
        }

        dictionaryInputsContainer.text('');

        let formElement;

        for (let dictionary of animal.dictionaries) {
            const type = parseInt(dictionary.type);

            if(type === 1) {
                if (dictionary.entries.length === 0) {
                    continue;
                }

                formElement = dictionaryInputTemplate.clone();
                formElement.find('select').attr('name', 'dictionary-' + dictionary.id);

                if(dictionary.is_required === "0") {
                    formElement.find('select').append(`
                        <option value="">Nie rozpoznano</option>
                    `);
                }

                for (let entry of dictionary.entries) {
                    formElement.find('select').append(`
                        <option value="${entry.id}">${entry.name}</option>
                    `);
                }

                dictionaryInputsContainer.append(formElement);
            } else {
                let inputTemplate = dictionaryNumberInputTemplate;
                if(type === 4) {
                    inputTemplate = dictionaryDateInputTemplate;
                } else if(type === 5) {
                    inputTemplate = dictionaryTextInputTemplate;
                }

                formElement = inputTemplate.clone();
                formElement.find('input').attr('name', 'dictionary-' + dictionary.id);
                formElement.find('input').attr('placeholder', dictionary.name)

                if(type === 2) {
                    formElement.find('input').attr('step', '1');
                } else if(type === 3) {
                    formElement.find('input').attr('step', '0.01')
                }

                if(type === 4) {
                    initDateInput(formElement.find('input'))
                }

                dictionaryInputsContainer.append(formElement);
            }

            formElement.find('.error[data-for]').attr('data-for', 'dictionary-' + dictionary.id);
            formElement.find('label').text(dictionary.name+` ${dictionary.is_required === "1" ? ' *' : ''}`);

            try {
                formElement.find('label').attr('for', formElement.find('label').attr('for').replace('PLACEHOLDER_NAME', 'dictionary-' + dictionary.id));
                formElement.find('select, input').attr('id', formElement.find('select, input').attr('id').replace('PLACEHOLDER_NAME', 'dictionary-' + dictionary.id));
            } catch(err) {}
        }
    })

    typeInput.change(function () {
        subtypeInput.find('option').remove();
        let animalType = tree.find(a => parseInt(a.id) === parseInt($(this).val()));

        if(!animalType) {
            return;
        }

        for (let animal of animalType.animals) {
            subtypeInput.append(`<option value="${animal.id}">${animal.name}</option>`);
        }

        if (animalType.animals.length > 0) {
            subtypeInput.val(animalType.animals[0].id).change();
        }

        if (animalType.animals.length > 1) {
            subtypeInput.closest('[class^=col-]').show();
        } else {
            subtypeInput.closest('[class^=col-]').hide();
        }
    }).change();
}